import {Button, Grid, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";

const TemplateHeader = (props) => {
    const { onCreate = new Function() } = props;
    const { i18n } = useTranslation();
    return (<Grid
        container
        spacing={0}
        justifyContent="space-between"
    >
        <Grid item>
            <Typography variant="h4" component="h1">
                {i18n.t("templates.ALL_TEMPLATES")}
            </Typography>
        </Grid>
        <Grid item>
            <Button
                variant="contained"
                color="primary"
                onClick={onCreate}
                sx={{ borderRadius: '20px' }}
            >
                {i18n.t("templates.CREATE_TEMPLATE")}
            </Button>
        </Grid>
    </Grid>);
}

export default TemplateHeader;